import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Injectable } from '@angular/core';

/**
 * External library to translate the page
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  /**
   * @ignore
   */
  constructor(private http: HttpClient) {}

  /**
   * Fetches the translation file for the language Transloco requests
   */
  getTranslation(lang: string) {
    return this.http.get<Translation>(`../assets/i18n/${lang}.json`);
  }
}
